import {
  RESET_FORGET_PASSWORD,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_SUCCESS,
} from "./actionTypes";

const initialState = {
  data: null,
  error: null,
  loading: false,
  success: false,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FORGET_PASSWORD:
      state = initialState;
      break;
    case FORGET_PASSWORD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        success: true,
        loading: false,
        error: null,
      };
      break;
    case SET_NEW_PASSWORD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SET_NEW_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        success: true,
        loading: false,
        error: null,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = {
        ...state,
        success: false,
        error: action.payload,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default forgetPassword;
